import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { apiEndpointURL } from '@core/constants/endpoints-url';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityService {
  httpClient = inject(HttpClient);
  saveAndAddFee$ = signal<boolean>(true);

  getAvailabilityJSONDetails() {
    const params = new HttpParams().set('headerNotRequired', true);
    return this.httpClient.get(apiEndpointURL.courseAvailabilityFieldJson, { params });
  }

  saveAvailabilityDetails(institutionId: any, courseId: any, instanceId: any, availabilityData: any, availabilityId?: any) {
    const saveAvailabilityUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'courses', courseId, 'courseInstances', instanceId, 'availabilities'].join('/');
    if (availabilityId)
      return this.httpClient.put(saveAvailabilityUrl + '/' + availabilityId, availabilityData);
    else
      return this.httpClient.post(saveAvailabilityUrl, availabilityData);
  }

  getAvailabilityData(institutionId: any, courseId: any, instanceId: any, availabilityId: any) {
    const availabiltyDetailsUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'courses', courseId, 'courseInstances', instanceId, 'availabilities', availabilityId].join('/');
    return this.httpClient.get(availabiltyDetailsUrl);
  }

  getAvalReferenceData() {
    return this.httpClient.get(apiEndpointURL.availabilityReferenceEndpoint);
  }

  getAvailabilityDetails(currentPageNo: number, overallRecordCount: number, institutionId: any, campusId: any, instanceId: any, academicYear: any) {
    const avlDataUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'campuses', campusId, 'availabilities'].join('/');
    const params = new HttpParams().set('pageSize', overallRecordCount).set('pageNumber', currentPageNo).set('academicYear', academicYear).set('courseInstanceId', instanceId);
    return this.httpClient.get(avlDataUrl, { params });
  }

  getCourseInstanceAvailability(institutionId: any, courseId: any, courseInstanceId: any, academicYear: any, pageNumber: number, pageSize: number, campusId?: any, filterSortDetails?: any) {
    const avlDataUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'courses', courseId, 'courseInstances', courseInstanceId, 'availabilities'].join('/');
    let params = new HttpParams().set('academicYear', academicYear).set('pageNumber', pageNumber).set('pageSize', pageSize);
    if (campusId)
      params = params.set('campusId', campusId);
    if (filterSortDetails?.sortBy)
      params = params.set('sortBy', filterSortDetails.sortBy);
    if (filterSortDetails?.sortOrder === 'desc')
      params = params.set('sortOrder', filterSortDetails.sortOrder);
    if (filterSortDetails?.filterData)
      Object.keys(filterSortDetails.filterData).forEach((data) => {
        params = params.set(data, filterSortDetails.filterData[data]);
      });
    return this.httpClient.get(avlDataUrl, { params });
  }

  getAvailabilityRefData(institutionId: any, courseId: any, courseInstanceId: any, campusId: any, academicYear: any, filterBy: any) {
    const avlDataUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'courses', courseId, 'courseInstances', courseInstanceId, 'availabilities/filterData'].join('/');
    let params = new HttpParams().set('academicYear', academicYear).set('filterBy', filterBy);
    if (campusId)
      params = params.set('campusId', campusId);
    return this.httpClient.get(avlDataUrl, { params });
  }

  getCampusAvailabilityData(institutionId: any, campusId: any, courseInstanceId: any, academicYear: any) {
    const avlDataUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'campuses', campusId, 'intakes'].join('/');
    const params = new HttpParams().set('pageSize', 1000).set('pageNumber', 1).set('year', academicYear).set('courseInstanceId', courseInstanceId);
    return this.httpClient.get(avlDataUrl, { params });
  }

  copyFromAvailabilityDetails(institutionId: any, courseId: any, courseInstanceId: any, copyFromDetails: any) {
    const copyFromAvailabilityUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'courses', courseId, 'courseInstances', courseInstanceId, 'availabilities/copy'].join('/');
    return this.httpClient.post(copyFromAvailabilityUrl, copyFromDetails);
  }
}
